import { pick } from "lodash"
import React from "react"

import type { ReactConsumer } from "@/lib/consume"

export const consumeContext = <
  ContextData,
  ProvideTo extends string,
  TakeOnly extends keyof ContextData | undefined = undefined
>({
  Context,
  provideTo,
  takeOnly,
}: {
  Context: React.Context<ContextData>
  provideTo: ProvideTo
  takeOnly?: TakeOnly[]
}) => {
  return function <
    NestedComponentProps extends ReactConsumer.ProvidedProps<
      ContextData,
      ProvideTo,
      TakeOnly
    >
  >(NestedComponent: React.ComponentType<NestedComponentProps>) {
    return function (
      externalProps: ReactConsumer.ExternalProps<
        NestedComponentProps,
        ProvideTo
      >
    ) {
      return (
        <Context.Consumer>
          {(contextData) => {
            const { [provideTo]: _, ...nestedProps } = externalProps
            const result = takeOnly
              ? pick(contextData, takeOnly as unknown as keyof ContextData[])
              : contextData

            return (
              <NestedComponent
                {...(nestedProps as NestedComponentProps)}
                {...{ [provideTo]: result }}
              />
            )
          }}
        </Context.Consumer>
      )
    }
  }
}
